export const DRAFT_SLUG = '_draft';
export const DRAFT_PARAM = 'config';

export function encodeDraftConfig(config) {
    const json = JSON.stringify(config);
    const bytes = new TextEncoder().encode(json);
    let binary = '';
    bytes.forEach((byte) => {
        binary += String.fromCharCode(byte);
    });
    return window.btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

export function decodeDraftConfig(encoded) {
    if (!encoded) return null;
    try {
        const padded = encoded.replace(/-/g, '+').replace(/_/g, '/');
        const binary = window.atob(padded + '='.repeat((4 - (padded.length % 4)) % 4));
        const bytes = Uint8Array.from(binary, (character) => character.charCodeAt(0));
        return JSON.parse(new TextDecoder().decode(bytes));
    } catch (error) {
        return null;
    }
}

export function buildDraftUrl(basePath, config, origin = window.location.origin) {
    return `${origin}/#${basePath}/${DRAFT_SLUG}?${DRAFT_PARAM}=${encodeDraftConfig(config)}`;
}
